










































import Vue from 'vue'
import Project from '@/models/Project.ts'
import CenteredSpinner from '@/components/CenteredSpinner.vue'
export default Vue.extend({
	components: {
		CenteredSpinner
	},
	refs: ['textArea'],

	props: {
		isLeaving: Boolean,
		project : Project,
		closeFunc : Function,
		refreshFunc : Function
	},
	data(){
		return {
			projectText: "",
			isProcessing: false
		}
	},
	methods:{
		async deleteProject(){
			this.isProcessing = true;
			try
			{
				if (this.isLeaving)
				{
					try
					{
						let form = new FormData();
						form.append("projectid", this.project.id);
						form.append("userid", this.user.userid);

						await this.$http.delete(`projects/users/id`, {data: form});
						this.closeFunc()
						this.refreshFunc()
					}
					catch(ex)
					{
						alert(`Failed to leave project: ${ex.response.data.error}`);
					}
				}
				else
				{
					try
					{
						let form = new FormData();
						await this.$http.post(`deleteproject?pid=${this.project.id}`);
						this.closeFunc()
						this.refreshFunc()
					}
					catch(ex)
					{
						alert(`Failed to delete project: ${ex.data.error}`);
					}
				}
			}
			finally
			{
				this.isProcessing = false;
			}
		}
	}
})
